<template>
  <!-- STATUS-->
  <v-container
    fluid
    class="mt-12 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-card dark>
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="d-flex justify-center text-center">
          <span class="text-h5" :style="'color: cyan;'">Kontynuuj płatność</span>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <v-text-field
            :style="'max-width: 400px;'"
            v-model="orderNumber"
            label="Numer zamówienia"
            counter="7"
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn @click="continuePayment" > Kontynuuj </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "OrderStatusView",
  data: () => ({
    orderNumber: "",
  }),
  components: {},
  methods: {
    continuePayment: function () {
      if (this.orderNumber.length != 7) {
        this.$toast.open({
          message: `<span class="font-weight-bold">Podaj poprawny numer zamówienia (7 znaków)!</span>`,
          type: "error",
          duration: 3000,
          position: "bottom",
        });
        return;
      }
      this.$router.push(`/platnosc/${this.orderNumber.toUpperCase()}`)
    },
  },
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
